import { BaseService } from '@/core/base-service';

export default class CountryService extends BaseService<any> {
  public constructor() {
    super('services/servicescard/api/public/country');
  }
}
